import {
    ISearch,
    ISearchProfile,
    ISearchProvider,
    HorizAlignment,
    SearchProviderFieldType,
    ISearchProviderField, ISearchRequestSubset
} from "../PA.UIM.Core/PA.UIM.Core.IF.Search"
import {PASearch} from "../PA.Core/PASearch";
import {SearchUtils} from "../PA.UIM.Core/SearchUtils";
import {ColumnNodeProvider} from "../PA.UIM.Core/SearchTreeUtils";
import {PAEnvironment} from "../PA.Core/PAEnvironment";
import * as _ from "lodash";

const vUI_Metric_Definition_Search_Fields: {[id:string]: ISearchProviderField } = {

    WB_MTRDFN_ID:           {type: SearchProviderFieldType.number, renderOptions: { columnName: 'WB Metric Id',   columnResourceName: 'colId', alignment: HorizAlignment.Center}, domainOptions: {}},
    METRIC_ID:              {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Metric Id',      columnResourceName: 'colId', alignment: HorizAlignment.Left}, domainOptions: { maxLength: 50}},
    METRIC_NAME:            {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Metric Name',    columnResourceName: 'colName', alignment: HorizAlignment.Left}, domainOptions: { maxLength: 256}},
    METRIC_USAGE:           {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Metric Usage',   columnResourceName: 'colMetricUsage', alignment: HorizAlignment.Right}, domainOptions: {maxLength: 50, domainIds: "Metric_Usage", useIdAsKey: true  }},
    METRIC_TYPE:            {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Metric Type',    columnResourceName: 'colMtrType', alignment: HorizAlignment.Right}, domainOptions: {maxLength: 50, domainIds: "Metric_Type",  useIdAsKey: true}},
    DISPLAY_TYPE:           {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Display Type',   columnResourceName: 'colDisplayType', alignment: HorizAlignment.Right}, domainOptions: {maxLength: 50, domainIds: "DataObject_Display_Type",  useIdAsKey: true}},
    METRIC_VERSION:         {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Metric Version', columnResourceName: 'colMtrVer', alignment: HorizAlignment.Right}, domainOptions: {maxLength: 50, domainIds: "MetricVersion",  useIdAsKey: true}},

    CUBESOURCE_ID:          {type: SearchProviderFieldType.string, renderOptions: { columnName: 'CubeSource Id', columnResourceName: 'colCubeSourceId', alignment: HorizAlignment.Left}, domainOptions: {profileId: "default", bUseSearchProvidersDistinctValues: true, maxLength: 50}},
    CUBESOURCE_NAME:        {type: SearchProviderFieldType.string, renderOptions: { columnName: 'CubeSource Name', columnResourceName: 'colCubeSourceName', alignment: HorizAlignment.Left}, domainOptions: {profileId: "default", bUseSearchProvidersDistinctValues: true, maxLength: 256}},

    WB_SUBJECTAREA_ID:      {type: SearchProviderFieldType.number, renderOptions: { columnName: 'Subject Area ID',   columnResourceName: 'colSubjAreaID', alignment: HorizAlignment.Right}, domainOptions: {}},
    SUBJECT_AREA_ID:        {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Subject Area Id',   columnResourceName: 'colSubjectAreaId', alignment: HorizAlignment.Left}, domainOptions: {profileId: "default", bUseSearchProvidersDistinctValues: true, maxLength: 50}},
    SUBJECT_AREA_NAME:      {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Subject Area Name', columnResourceName: 'colSubjectAreaName', alignment: HorizAlignment.Left}, domainOptions: {profileId: "default", bUseSearchProvidersDistinctValues: true, maxLength: 256}},
    SUBJECTAREA_COLUMNNAME: {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Column Name',       columnResourceName: 'colSubjAreaName', alignment: HorizAlignment.Right}, domainOptions: {maxLength: 50}},

    MANUAL_IND:             {type: SearchProviderFieldType.boolean, renderOptions: { columnName: 'Manual Ind', columnResourceName: 'colManual', alignment: HorizAlignment.Left, columnWidthCharacters: 5}, domainOptions: { maxLength: 1}},
    VISIBLE_IND:            {type: SearchProviderFieldType.boolean, renderOptions: { columnName: 'Visible', columnResourceName: 'colVisible', alignment: HorizAlignment.Left, columnWidthCharacters: 5}, domainOptions: { maxLength: 1}},
    EDITABLE_IND:           {type: SearchProviderFieldType.boolean, renderOptions: { columnName: 'Editable', columnResourceName: 'colEditable', alignment: HorizAlignment.Left, columnWidthCharacters: 5}, domainOptions: { maxLength: 1}},
    MINVALUE:               {type: SearchProviderFieldType.number, renderOptions:  { columnName: 'Minimum Value', columnResourceName: 'colMinValue', alignment: HorizAlignment.Left}, domainOptions: {}},
    MAXVALUE:               {type: SearchProviderFieldType.number, renderOptions:  { columnName: 'Maximum Value', columnResourceName: 'colMaxValue', alignment: HorizAlignment.Center}, domainOptions: {}},
    FORMULA:                {type: SearchProviderFieldType.string, renderOptions:  { columnName: 'Formula', columnResourceName: 'colFormula', alignment: HorizAlignment.Left}, domainOptions: {maxLength: 100}},
    COMPONENT_METRIC_COUNT: {type: SearchProviderFieldType.number, renderOptions:  { columnName: 'Component Count',   columnResourceName: 'colCount', alignment: HorizAlignment.Center}, domainOptions: {}},

    UOM_NUM:                {type: SearchProviderFieldType.string, renderOptions:  { columnName: 'Numerator UOM',  columnResourceName: 'colNumeratorUOM', alignment: HorizAlignment.Left}, domainOptions: { maxLength: 50}},
    UOM_DENOM:              {type: SearchProviderFieldType.string, renderOptions:  { columnName: 'Denominator UOM',  columnResourceName: 'colNumeratorUOM', alignment: HorizAlignment.Left}, domainOptions: { maxLength: 50}},
    PLOT_AXIS_NAME:         {type: SearchProviderFieldType.string, renderOptions:  { columnName: 'Plot Axis Name',  columnResourceName: 'colPlotAxisName', alignment: HorizAlignment.Left}, domainOptions: { maxLength: 50}},

    COPYPOLICY:             {type: SearchProviderFieldType.string, renderOptions:  { columnName: 'Copy policy', columnResourceName: 'colCopyPolicy', alignment: HorizAlignment.Center}, domainOptions: {maxLength: 1}},
    METRIC_FORMAT:          {type: SearchProviderFieldType.string, renderOptions:  { columnName: 'Metric Format', columnResourceName: 'colMetricFormat', alignment: HorizAlignment.Center}, domainOptions: {maxLength: 1333}},
    OPTIONS:                {type: SearchProviderFieldType.string, renderOptions:  { columnName: 'Option', columnResourceName: 'colOptions', alignment: HorizAlignment.Center}, domainOptions: {maxLength: 256}},
    FILTER_OPTIONS:         {type: SearchProviderFieldType.string, renderOptions:  { columnName: 'Filter Options', columnResourceName: 'colFltrOpts', alignment: HorizAlignment.Right}, domainOptions: {maxLength: 1333}},
    GL_ACCOUNT_FILTER_IND:  {type: SearchProviderFieldType.boolean, renderOptions: { columnName: 'GL Account Filter Ind', columnResourceName: 'colGLAcct', alignment: HorizAlignment.Right}, domainOptions: {}},
    EVTS_TYPE_FILTER_IND:  {type: SearchProviderFieldType.boolean, renderOptions: { columnName: 'Spend Type Filter Ind', columnResourceName: 'colSpendType', alignment: HorizAlignment.Right}, domainOptions: {}},

    CREATED_DTTS: {
        type: SearchProviderFieldType.sapdate,
        renderOptions: {
            columnName: 'Created Date',
            columnResourceName: 'colCreateDt',
            alignment: HorizAlignment.Center,
            dateFormat: "MM-dd-yy"
        },
        domainOptions: {}
    },
    MODIFIED_DTTS: {
        type: SearchProviderFieldType.sapdate,
        renderOptions: {
            columnName: 'Modified Date',
            columnResourceName: 'colModifiedDt',
            alignment: HorizAlignment.Center,
            dateFormat: "MM-dd-yy"
        },
        domainOptions: {}
    }
}



const MetricDefinitionSearchProviderBasic: ISearchProvider =
    {
        keyFields: {id:'WB_MTRDFN_ID',
            id_ui:     'METRIC_ID',
            name:      'METRIC_NAME'
        },

        searchProviderFields: vUI_Metric_Definition_Search_Fields,


        search(searchOptions: ISearchRequestSubset): Promise<any[]> {
            return new Promise<any[]>((resolve, error) => {

                let findRequest = SearchUtils.makeSearchRequest(searchOptions,
                    'vUI_Metric_Definition_Search',
                    this.searchProviderFields,
                    []);

                PASearch.findByRequest(findRequest)
                    .then((res: any[]) => {
                        resolve(res)
                    })
                    .catch((err)=> {
                        error(err)
                    })
            })
        },

        distinctValues(fieldName: string, condition?: any): Promise<string[] | number[]> {
            return new Promise<string[] | number[]>((resolve, error) => {
                let findRequest = SearchUtils.makeSearchRequest({},
                    'vUI_Metric_Definition_Search',
                    this.searchProviderFields,
                    [fieldName])

                PASearch.findByRequest(findRequest)
                    .then((res: any[]) => {

                        resolve(_.map(res, (aRow) => { return aRow[fieldName] }))
                    })
                    .catch((err)=> {
                        error(err)
                    })
            })
        }
    };


const MetricDefinitionSearchProfileByName: ISearchProfile = {
    profileId: "default",
    profileName: "Search by Id, Name, Usage",
    renderOptions: { ui5ResourceId: "MetricDefinitionSearchProfileByName" },


    profileFilter: [
        //{profileFilterName: 'Metric Definition',        searchProviderFieldId: 'WB_MTRDFN_ID',   renderOptions: { }},
        {profileFilterName: 'Metric Id',         searchProviderFieldId: 'METRIC_ID',         renderOptions: { }},
        {profileFilterName: 'Metric Name',       searchProviderFieldId: 'METRIC_NAME',       renderOptions: { }},
        {profileFilterName: 'Metric Type',       searchProviderFieldId: 'METRIC_TYPE',       renderOptions: { }, bMultiSelect: true},
        {profileFilterName: 'Data Entry Usage',  searchProviderFieldId: 'METRIC_USAGE',      renderOptions: { }, bMultiSelect: true},
        {profileFilterName: 'Subject Area',      searchProviderFieldId: 'SUBJECT_AREA_NAME', renderOptions: { }, bMultiSelect: true},
        {profileFilterName: 'Cube Source',       searchProviderFieldId: 'CUBESOURCE_NAME',   renderOptions: { }, bMultiSelect: true}
    ],  // ISearchFields

    profileDisplayFields: [
        'METRIC_ID','METRIC_NAME','METRIC_TYPE',
        'EDITABLE_IND','FORMULA',
        'SUBJECT_AREA_NAME', 'SUBJECTAREA_COLUMNNAME',
        'CUBESOURCE_NAME',
        'VISIBLE_IND', 'DISPLAY_TYPE',
        'UOM_NUM','UOM_DENOM', 'PLOT_AXIS_NAME',
        'MANUAL_IND', 'CREATED_DTTS', 'MODIFIED_DTTS'
    ], //string[];   // Search Provider Field Name (Use to Generate Grid Columns)

    profileSearchProvider: MetricDefinitionSearchProviderBasic,

    profileTreeIdDefault: "ByMetricDefinition",
    profileTrees: [

        {treeId: "ByMetricSubjectArea",
            treeName: "By Metric Subject Area",
            nodeProviders: [new ColumnNodeProvider(['SUBJECT_AREA_NAME'], {defaultValues: "Non Subject Area Metrics"})],
            renderOptions: {}},
        {treeId: "ByMetricCubeSource",
            treeName: "By Metric Cube Source ",
            nodeProviders: [new ColumnNodeProvider(['CUBESOURCE_NAME'], {defaultValues: "Non Cube Source Metrics"})],
            renderOptions: {}},
        {treeId: "ByMetricDefinitionUsage",
            treeName: "By Metric Definition Usage",
            nodeProviders: [new ColumnNodeProvider(['METRIC_TYPE', 'METRIC_USAGE'], {defaultValues: "Empty Metric Definition Usage"})],
            renderOptions: {}}
    ],

    // Do sorting last.. not necessary for phase 1
    profileSortIdDefault: "",    //string;
    profileSorts: [] //ISearchSort[];
};

const MetricDefinitionSearch: ISearch = {
    searchName: "Find Metric Definition",
    renderOptions: { ui5ResourceId: "MetricDefinitionSearch"},
    searchProfileIdDefault: "default",
    searchProfiles: [MetricDefinitionSearchProfileByName]
};

_.forEach(vUI_Metric_Definition_Search_Fields, (colSpec) => {
    if(colSpec.domainOptions.bUseSearchProvidersDistinctValues && !colSpec.domainOptions.search)
        colSpec.domainOptions.search = MetricDefinitionSearch
})
PAEnvironment.registerBusinessObjectSearch("MetricDefinitionBO", "MetricDefinition", MetricDefinitionSearch, "Metric Definition Search")


export {MetricDefinitionSearch}

